module.exports = __webpack_public_path__ + "static/heimat-01-8997400bf7b588fbd50e2a639314af1f.jpg";